const appAPiUrl = process.env.REACT_APP_API_URL;
const reportingApiUrl = process.env.REACT_APP_REPORT;
const mainUrl = window.location.hostname === 'localhost' ? 'http://localhost:9000/' : appAPiUrl;
const reportingUrl = window.location.hostname === 'localhost' ? 'http://localhost:9200/' : reportingApiUrl;
import { logout } from '../components/Security/securityReducer';
export const apiCall = async (options) => {
  const token = sessionStorage.getItem('token');
  const url = (options.reportingUrl ? reportingUrl : mainUrl) + options.url;
  return fetch(url, {
    method: options.method || 'GET',
    headers: {
      ...(options.noAuth ? {} : { Authorization: `${token}` }),
      ...(options.notJSON ? {} : { 'Content-Type': 'application/json' }),
      ...options.headers,
    },
    body: options.body ? (options.stringify ? JSON.stringify(options.body) : options.body) : null,
  })
    .then(async (response) => {
      const errorToReturn = options.errorObject
        ? { ...options.errorObject, status: response.status }
        : { error: options.errorMessage || 'There was an error processing your request.', status: response.status };

      if (response.status === 401) {
        const responseData = await response.json();
        const isUnauthorized = responseData?.message === 'Unauthorized access.';

        if (options.checkSessionOut || isUnauthorized) {
          console.log('Session expired, logging out...');
          checkForSessionOut(response);

          if (isUnauthorized) {
            window.location.href = '/login?sessionExpired=true';
          }
        }
      } else if (options.onResponse) {
        console.log('Response received:', response);
        return await options.onResponse(response);
      } else if (response.status >= 400) throw new Error('Network request failed');
      else if (response.status === 200) {
        if (options.onSuccess) return options.onSuccess(response);
        else return await response.json();
      } else if (options.onError) return await options.onError(response);
      else if (options.throwOnError) throw new Error(errorToReturn);
      else {
        console.error(errorToReturn);
        return errorToReturn;
      }
    })
    .catch((error) => {
      if (options.onFailure) return options.onFailure(error);
      else {
        console.error('API call failed:', error);
        throw error;
      }
    });
};

export const uploadPDF = async (formData) => {
  const token = sessionStorage.getItem('token');
  const urlForPDFUpload = `${mainUrl}docreader/upload`;

  const response = await fetch(urlForPDFUpload, {
    method: 'POST',
    body: formData,
    headers: {
      Authorization: `${token}`,
    },
  });

  if (response.status >= 400) {
    const errorMessage = await response.json();
    throw new Error(errorMessage.message || errorMessage.error);
  }
  return await response.json();
};

export const downloadPDF = async (consignmentId) => {
  const token = sessionStorage.getItem('token');
  const urlForPDFUpload = `${mainUrl}ens/getDocument/${consignmentId}`;

  const response = await fetch(urlForPDFUpload, {
    method: 'GET',
    headers: {
      Authorization: `${token}`,
    },
  });

  if (response.status >= 400) {
    throw new Error('Network request failed');
  }
  return await response.json();
};

export function checkForSessionOut(response) {
  if (response.status === 401) {
    logout();
  }
}
